
import apiClient from './api';

export const getAccountType = async () => {
  try {
    const response = await apiClient.get('/api/accountType');
    return response.data;
  } catch (error) {
    throw new Error("Erreur lors de la récupération des types de comptes:", error);
  }
};
